const analyticsMiddleware = () => next => action => {
  window.dataLayer = window.dataLayer || [];
  if (
    action.type === "MOVE_DUE_RESULT" ||
    action.type === "PAY_NOW_RESULT" ||
    action.type === "PAYMENT_DONE" ||
    action.type === "CREATE_PLAN_RESULT" ||
    action.type === "FETCH_PLAN_RESULT" ||
    action.type === "ANALYTICS_DUE"
  ) {
    window.dataLayer.push({
      event: action.type,
      payload: action.payload
    });
  }
  return next(action);
};

export default analyticsMiddleware;



// WEBPACK FOOTER //
// ./src/analyticsMiddleware.js